import React from 'react';
import PropTypes from 'prop-types';

export default function FixList({ title, items }) {
  if (!items?.length) return null;

  return (
    <div className="mb-3">
      <h6>{title}</h6>
      <ul className="list-unstyled mb-0">
        {items.map((item, idx) => (
          <li key={idx}>
            <strong>{item.importance?.toUpperCase()}</strong>: {item.explanation}
            {item.scene_numbers?.length > 0 && (
              <span className="text-muted ms-2">
                [Scenes: {item.scene_numbers.map(s => s.scene ?? s).join(', ')}]
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

FixList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      importance: PropTypes.string,
      explanation: PropTypes.string,
      scene_numbers: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.shape({ scene: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
          PropTypes.string,
          PropTypes.number
        ])
      )
    })
  )
};
